import { luscinia } from "../luscinia";
import { constructBootgridFormatters } from "./bootgridFormatters";
import ParameterBootgridManager from "./parameter-bootgrid-manager";
import { BootgridSettings } from "./bootgridSettings";
import { BootgridChangeType } from "./bootgridTypes";
import { postValueChange } from "../wizard";

export default class ParameterBootgrid {
    private readonly config: Config;
    private readonly bootgridSettings: BootgridSettings;
    private readonly $bootgrid: JQuery<HTMLElement>;
    private readonly name: string;
    private readonly bootgridManager: ParameterBootgridManager;

    constructor(config: Config, tableElement: HTMLTableElement) {
        this.config = config;
        this.name = tableElement.dataset.lusciniaTablename;
        this.$bootgrid = $(tableElement);
        this.bootgridSettings = new BootgridSettings(this.$bootgrid, config);
        if (!this.bootgridSettings.isParameterBootgrid) {
            throw new Error("This is not a parameter bootgrid.")
        }
        this.bootgridManager = new ParameterBootgridManager(this.$bootgrid);
    }

    init() {
        (this.$bootgrid as any)
            .on("loaded.rs.jquery.bootgrid", () => {
                const editBtns = this.$bootgrid.find(".command-edit");
                editBtns.each((index, element) => {
                    $(element).on("click", (e) => {
                        e.stopPropagation();
                        const rowId = $(e.currentTarget).closest("tr").data("row-id");
                        luscinia.openCustomModalEdit(`/data/${this.name}`, rowId, "");
                    });
                });
            })
            .on("selected.rs.jquery.bootgrid", (e: Event, rows: object[]) => {
                if (this.hasPostValueChange()) {
                    const additionalFormData = this.bootgridSettings.allowMultiSelect
                        ? this.bootgridManager.getPostValueChangeFormData(rows, BootgridChangeType.select)
                        : null;
                    this.postValueChange(additionalFormData);
                }
            })
            .on("deselected.rs.jquery.bootgrid", (e: Event, rows: object[]) => {
                if (this.hasPostValueChange()) {
                    const additionalFormData = this.bootgridSettings.allowMultiSelect
                        ? this.bootgridManager.getPostValueChangeFormData(rows, BootgridChangeType.deselect)
                        : null;
                    this.postValueChange(additionalFormData);
                }
            })
            .bootgrid({
                ajax: false,
                selection: true,
                multiSelect: true,
                rowSelect: true,
                rowCount: -1,
                navigation: 0,
                formatters: constructBootgridFormatters(this.$bootgrid, this.bootgridSettings, this.config),
            });
    }
    private hasPostValueChange() {
        return this.$bootgrid.attr("data-luscinia-bootgrid-postvaluechange") === "true";
    }

    private postValueChange(additionalData: FormData = null) {
        let wizardForm = $(".block-wizard").find("form") as JQuery<HTMLFormElement>;
        let parameterName = $(".block-wizard").data("parameter");
        postValueChange.call(this.$bootgrid[0], wizardForm, parameterName, this.$bootgrid.attr("data-luscinia-field-name"), additionalData);
    }
}
